/**
 * Product Carousel — dedup prodotti tra caroselli home
 *
 * Problema: le sezioni OS 2.0 sono renderizzate isolate (niente variabili
 * Liquid condivise tra sezioni), quindi due caroselli "product-carousel"
 * consecutivi in home (es. "Offerte del momento" e "Cura dei Capelli")
 * possono pescare da collezioni Shopify che si sovrappongono e mostrare
 * più volte lo stesso prodotto, uno immediatamente sotto l'altro.
 *
 * Soluzione: dopo che ogni sezione [data-product-carousel] si è
 * inizializzata (vedi assets/product-carousel.js, caricato prima di
 * questo script — layout/theme.liquid), scansioniamo tutti i caroselli
 * presenti in home nell'ordine in cui appaiono nel DOM, teniamo traccia
 * degli handle prodotto già mostrati e nascondiamo (senza rimuovere dal
 * DOM, per non rompere il conteggio card/frecce) le card duplicate nei
 * caroselli successivi al primo.
 *
 * Usiamo una classe CSS dedicata (pc-dedupe-hide) invece di riusare
 * "pc-hide" per non entrare in conflitto con la logica dei tab filtro
 * (product-carousel.js aggiunge/rimuove "pc-hide" in base al tab attivo:
 * se riusassimo quella classe, un click sul tab "Tutti" rimuoverebbe
 * anche il nostro nascondimento duplicati).
 */
(function () {
  'use strict';

  var DUP_CLASS = 'pc-dedupe-hide';

  function getProductHandle(item) {
    var card = item.querySelector('[data-product-handle]');
    return card ? card.getAttribute('data-product-handle') : null;
  }

  function runDedupe() {
    var carousels = document.querySelectorAll('[data-product-carousel]');
    if (carousels.length < 2) return; // niente da confrontare

    var seen = Object.create(null);

    carousels.forEach(function (section) {
      var items = section.querySelectorAll('.product-carousel__item');

      items.forEach(function (item) {
        // Si ricalcola sempre da zero: un prodotto nascosto in un
        // passaggio precedente potrebbe non essere più un duplicato
        // (es. dopo un cambio tab in un carosello con filtri).
        item.classList.remove(DUP_CLASS);

        // Card nascosta dal proprio carosello perché il suo tab/filtro
        // non è quello attivo: non è "mostrata", quindi non conta né
        // come prodotto già visto né come duplicato da nascondere.
        if (item.classList.contains('pc-hide')) return;

        var handle = getProductHandle(item);
        if (!handle) return; // es. card "Vedi tutti", senza prodotto

        if (seen[handle]) {
          item.classList.add(DUP_CLASS);
        } else {
          seen[handle] = true;
        }
      });
    });

    // Nascondere delle card cambia scrollWidth/clientWidth dei track:
    // un resize "sintetico" fa ricalcolare la visibilità delle frecce a
    // ogni istanza di carosello (product-carousel.js è in ascolto su
    // window resize).
    window.dispatchEvent(new Event('resize'));
  }

  // Script caricato con `defer` DOPO tutte le occorrenze di
  // product-carousel.js (vedi layout/theme.liquid): all'esecuzione, ogni
  // carosello è già inizializzato e lo stato iniziale dei tab (se
  // presenti) è già applicato, quindi possiamo girare subito.
  runDedupe();

  // Un cambio tab in un carosello con filtri (es. "Cura dei Capelli") può
  // rendere visibili prodotti diversi: ricalcoliamo i duplicati. Il
  // listener del tab in product-carousel.js è sul bottone stesso e gira
  // prima (in bubbling) di questo, ma rimandiamo comunque al tick
  // successivo per sicurezza.
  document.addEventListener('click', function (event) {
    var tab = event.target.closest ? event.target.closest('[data-filter]') : null;
    if (tab) {
      window.setTimeout(runDedupe, 0);
    }
  });

  // Ricalcolo finale dopo il caricamento completo (immagini, webfont…)
  // per assicurare che le frecce riflettano le larghezze reali.
  window.addEventListener('load', function () {
    window.dispatchEvent(new Event('resize'));
  });
})();
